import React, { Component } from "react"
import { Link } from 'react-router-dom'
import actions from "./actions/root_action"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import "../../i18n"
import moment from 'moment'
import StringHelper from "../../common/helpers/string_helper"
import "./main_container.scss"
import Hero from "./hero"
import PrefectureProperties from "./prefecture_properties"
import SearchForm from "./search_form"
import { LoadingComponent } from '../../common/components/loading_component'
import { ucfirst } from '../../search/index/utils'
import { countryPrefectureNames } from '../../common/constants/prefectures'
import Modal from '../../common/components/modal_dialog/modal_wrapper_component'

const PREFECTURES = countryPrefectureNames()

const BREAKPOINTS = {
  SP: '(max-width: 767px)',
  Tablet: '(max-width: 1023px)'
}

export class Main extends Component {
  constructor (props) {
    super(props)

    this.checkWidth = ({ media, matches }) => {
      const device = Object.keys(BREAKPOINTS).find((device) => BREAKPOINTS[device] == media)
      this.props.actions.search.setState({ [`is${device}`]: matches })
    }

    Object.keys(BREAKPOINTS).forEach((device) => {
      this.mediaQuery = this.mediaQuery || {}
      this.mediaQuery[device] = window.matchMedia(BREAKPOINTS[device])
      this.checkWidth(this.mediaQuery[device])
      this.mediaQuery[device].addListener(this.checkWidth)
    })

    this.state = {
      prefectures: []
    }

    moment.locale(languageHelper.pageLocale)

    this.onSubmitForm = this.onSubmitForm.bind(this)
  }

  async componentDidMount() {
    delete this._query
    await this.props.actions.lp.getData()
    await this.loadPrefectures()
    this.loadProperties()
    this.props.actions.propertyTypes.get()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search != this.props.location.search) {
      this.loadProperties()
    }
  }

  get query() {
    const { search } = this.props.location
    if (search != this._search) {
      delete this._query
      this._search = search
    }
    return (this._query = this._query || queryString.parse(search, { arrayFormat: this.arrayFormat }))
  }

  get propertyIds() {
    if (this.props.lp && this.props.lp.properties) {
      return this.props.lp.properties.map(property => property.property_id)
    }

    return []
  }

  async loadPrefectures() {
    const { payload } = await this.props.actions.search.getRoomGroups({
      property_id: this.propertyIds,
      limit: 0,
      country_code: 'jp',
      count: 'prefectures'
    })

    if (payload.aggregations) {
      this.setState({
        prefectures: payload.aggregations.prefectures.buckets
      })
    }
  }

  loadProperties() {
    if (this.propertyIds.length) {
      const prefecture = this.state.prefectures.find(({ key }) => key == this.query.prefecture) || this.state.prefectures[0]

      this.props.actions.search.getRoomGroups({
        ...this.query,
        property_id: this.propertyIds,
        prefecture: prefecture.key,
        limit: 400
      })
    }
  }

  get roomGroups() {
    const { room_groups: roomGroups } = this.props.search

    return roomGroups
      .reduce((prefectures, roomGroup) => {
        const prefName = StringHelper.getPreferredLanguageString(
          roomGroup.property.prefecture,
          languageHelper.pageLocale
        )
        prefectures[prefName] = prefectures[prefName] || {}
        prefectures[prefName][roomGroup.property.id] =
        prefectures[prefName][roomGroup.property.id] || []
        prefectures[prefName][roomGroup.property.id].push(roomGroup)
        return prefectures
      }, {})
  }

  renderPrefectureFilter() {
    return (
      <section styleName="wrapper">
        <h2 styleName="search-heading">対象の宿泊・民泊施設</h2>
        <ul styleName="prefecture-list">
          {this.state.prefectures.map(({ key }, index) => {
            return <li styleName="prefecture" key={index}>
              <Link styleName="prefecture-navi" to={routeUrlHelper.featureTeleworkPath({ ...this.query, prefecture: key })}>
                { PREFECTURES[key] }
              </Link>
            </li>
          })}
        </ul>
      </section>
    )
  }

  onSubmitForm(state) {
    this.props.history.push(routeUrlHelper.featureTeleworkPath(state))
  }

  render() {
    const { isSP, isTablet } = this.props.search
    const { query, roomGroups } = this
    const prefectureProperties = this.props.search.room_groups.length
      ? Object.keys(this.roomGroups).map((prefecture, index) => {
        return <PrefectureProperties
          key={index}
          isSP={isSP}
          isTablet={isTablet}
          query={query}
          propertyTypes={this.props.propertyTypes}
          roomGroups={roomGroups}
          prefecture={prefecture}
          prefectureProperties={roomGroups[prefecture]} />
      })
      : <div styleName="property-not-found">一致する情報は見つかりませんでした。</div>

    return (
      <React.Fragment>
        <article styleName="wrapper" className="contents">
          <Hero />
          {this.renderPrefectureFilter()}
          <SearchForm
            lang={languageHelper.pageLocale}
            heading="空室検索"
            location={this.props.location}
            query={this.query}
            prefectures={this.state.prefectures}
            onSubmitForm={this.onSubmitForm}
          />
          <LoadingComponent overlay={false} requesting={!this.props.search.isFetched} message="検索中" />
          <div styleName={!this.props.search.isFetched ? 'hidden' : ''}>
            { prefectureProperties }
          </div>
        </article>
        <Modal />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal,
    search: state.search,
    propertyTypes: state.propertyTypes,
    lp: state.lp
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(Main)
